import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "bg-emerald-50 border border-emerald-300 rounded-xl p-5 mb-6"
}
const _hoisted_2 = { class: "flex items-start gap-3" }
const _hoisted_3 = { class: "flex-1 min-w-0" }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = { class: "flex-1 bg-white border border-emerald-200 rounded-lg px-3 py-2 text-sm font-mono break-all" }
const _hoisted_6 = { class: "flex items-center justify-between mb-6" }
const _hoisted_7 = { class: "text-sm text-gray-600" }
const _hoisted_8 = { class: "text-xs bg-gray-100 px-1.5 py-0.5 rounded" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" }
const _hoisted_11 = { class: "overflow-x-auto" }
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = { class: "divide-y divide-gray-200" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  colspan: "5",
  class: "px-6 py-16 text-center"
}
const _hoisted_16 = { class: "px-6 py-4 text-sm font-medium text-gray-900" }
const _hoisted_17 = { class: "px-6 py-4" }
const _hoisted_18 = { class: "text-sm font-mono text-gray-600" }
const _hoisted_19 = { class: "px-6 py-4 text-sm text-gray-600" }
const _hoisted_20 = { class: "px-6 py-4 text-sm text-gray-600" }
const _hoisted_21 = { class: "px-6 py-4" }
const _hoisted_22 = {
  key: 0,
  class: "px-3 py-1 rounded-full text-xs font-semibold bg-gray-200 text-gray-600"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "bg-white rounded-2xl shadow-2xl max-w-md w-full" }
const _hoisted_25 = { class: "p-6 border-b border-gray-200 flex items-center justify-between" }
const _hoisted_26 = {
  key: 0,
  class: "bg-red-50 border border-red-200 rounded-lg p-3"
}
const _hoisted_27 = { class: "text-sm text-red-600" }
const _hoisted_28 = { class: "flex gap-3 pt-2" }
const _hoisted_29 = ["disabled"]

import { ref, computed, onMounted } from 'vue'
import { Icon } from '@iconify/vue'
import { apiFor, apiBaseUrlFor, isEnvironmentUnauthorized } from '../services/api'
import EnvironmentUnavailable from '../components/EnvironmentUnavailable.vue'
import { useModeStore } from '../store/mode'
import { useAuthStore } from '../store/auth'
import { useNotification } from '../composables/useNotification'


export default /*@__PURE__*/_defineComponent({
  __name: 'ApiKeysView',
  setup(__props) {

const modeStore = useModeStore()
const authStore = useAuthStore()
const notify = useNotification()

const keys = ref<any[]>([])
const loading = ref(true)
const envUnavailable = ref(false)
const showCreateModal = ref(false)
const newKeyName = ref('')
const creating = ref(false)
const error = ref('')
const revealedSecret = ref('')
const copied = ref(false)

const baseUrl = computed(() => apiBaseUrlFor(modeStore.mode))

onMounted(load)

async function load() {
  loading.value = true
  try {
    const { data } = await apiFor(modeStore.mode).get('/partner-portal/api-keys')
    keys.value = data.keys || []
  } catch (err) {
    envUnavailable.value = isEnvironmentUnauthorized(err)
    console.error('Erreur chargement clés:', err)
    keys.value = []
  } finally {
    loading.value = false
  }
}

async function create() {
  creating.value = true
  error.value = ''
  try {
    const { data } = await apiFor(modeStore.mode).post('/partner-portal/api-keys', {
      name: newKeyName.value,
    })
    revealedSecret.value = data.secret
    showCreateModal.value = false
    newKeyName.value = ''
    await load()
  } catch (err: any) {
    error.value = err.response?.data?.message || 'Erreur lors de la création'
  } finally {
    creating.value = false
  }
}

async function revoke(key: any) {
  if (
    !window.confirm(
      `Révoquer la clé « ${key.name} » ? Toute requête l'utilisant sera immédiatement refusée.`
    )
  ) {
    return
  }
  try {
    await apiFor(modeStore.mode).delete(`/partner-portal/api-keys/${key.id}`)
    notify.success('Clé révoquée')
    await load()
  } catch (err: any) {
    notify.error(err.response?.data?.message || 'Erreur lors de la révocation')
  }
}

async function copy(text: string) {
  try {
    await navigator.clipboard.writeText(text)
    copied.value = true
    setTimeout(() => (copied.value = false), 2000)
  } catch {
    notify.error('Copie impossible — sélectionnez le texte manuellement')
  }
}

function formatDate(value: string): string {
  return new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (envUnavailable.value)
      ? (_openBlock(), _createBlock(EnvironmentUnavailable, {
          key: 0,
          class: "mb-6"
        }))
      : _createCommentVNode("", true),
    (revealedSecret.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(Icon), {
              icon: "solar:key-bold",
              class: "w-6 h-6 text-emerald-700 flex-shrink-0 mt-0.5"
            }),
            _createElementVNode("div", _hoisted_3, [
              _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "font-semibold text-emerald-900 mb-1" }, "Votre nouvelle clé API", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-sm text-emerald-800 mb-3" }, " Copiez-la maintenant : pour des raisons de sécurité, elle ne sera plus jamais affichée. ", -1)),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("code", _hoisted_5, _toDisplayString(revealedSecret.value), 1),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (copy(revealedSecret.value))),
                  class: "px-3 py-2 bg-emerald-600 text-white rounded-lg text-sm font-medium hover:bg-emerald-700 flex-shrink-0"
                }, _toDisplayString(copied.value ? 'Copié ✓' : 'Copier'), 1)
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (revealedSecret.value = '')),
              class: "text-emerald-700 hover:text-emerald-900 flex-shrink-0"
            }, [
              _createVNode(_unref(Icon), {
                icon: "solar:close-circle-bold",
                class: "w-5 h-5"
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("p", _hoisted_7, [
        _cache[9] || (_cache[9] = _createTextVNode(" Les clés de cet écran sont des clés ", -1)),
        _createElementVNode("strong", null, _toDisplayString(_unref(modeStore).isTest ? 'de test (yk_test_…)' : 'de production (yk_live_…)'), 1),
        _cache[10] || (_cache[10] = _createTextVNode(", utilisables uniquement contre ", -1)),
        _createElementVNode("code", _hoisted_8, _toDisplayString(baseUrl.value), 1),
        _cache[11] || (_cache[11] = _createTextVNode(". ", -1))
      ]),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (showCreateModal.value = true)),
        disabled: _unref(authStore).isSuspended,
        class: "px-4 py-2 bg-[#8C0004] text-white rounded-lg text-sm font-medium hover:bg-red-900 disabled:opacity-50 transition-colors flex items-center gap-2"
      }, [
        _createVNode(_unref(Icon), {
          icon: "solar:add-circle-bold",
          class: "w-4 h-4"
        }),
        _cache[12] || (_cache[12] = _createTextVNode(" Nouvelle clé ", -1))
      ], 8, _hoisted_9)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("table", _hoisted_12, [
          _cache[15] || (_cache[15] = _createElementVNode("thead", { class: "bg-gray-50 border-b border-gray-200" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Nom"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Clé"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Dernière utilisation"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Créée le"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_13, [
            (loading.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (i) => {
                  return _createElementVNode("tr", {
                    key: `s-${i}`,
                    class: "animate-pulse"
                  }, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("td", {
                      colspan: "5",
                      class: "px-6 py-4"
                    }, [
                      _createElementVNode("div", { class: "h-4 bg-gray-100 rounded" })
                    ], -1)
                  ]))])
                }), 64))
              : (keys.value.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                    _createElementVNode("td", _hoisted_15, [
                      _createVNode(_unref(Icon), {
                        icon: "solar:key-bold",
                        class: "w-10 h-10 text-gray-300 mx-auto mb-3"
                      }),
                      _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-gray-500" }, "Aucune clé API dans cet environnement.", -1))
                    ])
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(keys.value, (k) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: k.id,
                      class: _normalizeClass(['hover:bg-gray-50 transition-colors', k.revokedAt ? 'opacity-50' : ''])
                    }, [
                      _createElementVNode("td", _hoisted_16, _toDisplayString(k.name), 1),
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("code", _hoisted_18, _toDisplayString(k.prefix) + "…", 1)
                      ]),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(k.lastUsedAt ? formatDate(k.lastUsedAt) : 'Jamais utilisée'), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(formatDate(k.createdAt)), 1),
                      _createElementVNode("td", _hoisted_21, [
                        (k.revokedAt)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, " Révoquée "))
                          : (!_unref(authStore).isSuspended)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                onClick: ($event: any) => (revoke(k)),
                                class: "px-3 py-1 border border-[#8C0004] text-[#8C0004] rounded text-xs font-medium hover:bg-red-50"
                              }, " Révoquer ", 8, _hoisted_23))
                            : _createCommentVNode("", true)
                      ])
                    ], 2))
                  }), 128))
          ])
        ])
      ])
    ]),
    (showCreateModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4",
          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (showCreateModal.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _cache[16] || (_cache[16] = _createElementVNode("h3", { class: "text-lg font-bold text-gray-900" }, "Nouvelle clé API", -1)),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showCreateModal.value = false)),
                class: "text-gray-400 hover:text-gray-600"
              }, [
                _createVNode(_unref(Icon), {
                  icon: "solar:close-circle-bold",
                  class: "w-6 h-6"
                })
              ])
            ]),
            _createElementVNode("form", {
              onSubmit: _withModifiers(create, ["prevent"]),
              class: "p-6 space-y-4"
            }, [
              _createElementVNode("div", null, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " Nom de la clé ", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newKeyName).value = $event)),
                  type: "text",
                  maxlength: "100",
                  required: "",
                  placeholder: "Ex: Serveur de production",
                  class: "w-full rounded-lg border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#8C0004]"
                }, null, 512), [
                  [_vModelText, newKeyName.value]
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-xs text-gray-500 mt-2" }, " Ce libellé vous aide à identifier la clé : donnez-lui le nom du service qui l'utilisera. ", -1))
              ]),
              (error.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("p", _hoisted_27, _toDisplayString(error.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (showCreateModal.value = false)),
                  class: "flex-1 px-4 py-2.5 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50"
                }, " Annuler "),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: !newKeyName.value || creating.value,
                  class: "flex-1 px-4 py-2.5 bg-[#8C0004] text-white rounded-lg text-sm font-medium hover:bg-red-900 disabled:opacity-50"
                }, _toDisplayString(creating.value ? 'Création...' : 'Créer la clé'), 9, _hoisted_29)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})